import React, { Suspense } from 'react';

import { Loading } from 'client-web-sdk';

import useStoredClientCoreParameters from 'src/util/localStorage/useStoredClientCoreParameters';

const App = React.lazy(() => import('./App'));

export default function AppWrapper() {
  const { clientCoreParametersStatus, setClientCoreParameters } = useStoredClientCoreParameters();
  if (clientCoreParametersStatus.type === 'loading') {
    return <Loading />;
  }
  return (
    <Suspense fallback={<Loading />}>
      <App
        clientCoreParameters={
          clientCoreParametersStatus.type === 'empty' ?
            undefined
          : clientCoreParametersStatus.clientCoreParameters
        }
        setClientCoreParameters={setClientCoreParameters}
      />
    </Suspense>
  );
}
